<template>
  <ModalConfirm
    :modalName="modalId"
    title="Filtros adicionais"
    subtitle=""
    headerIcon="b-icon-filter"
    typeModal="success"
    sizeModal="md"
    stacked
    leftButtonText="Cancelar"
    rightButtonText="Aplicar filtros"
    :rightButtonClick="apply"
  >
    <div class="additional-filters-content">
      <div class="additional-filters-controls">
        <label class="additional-filters-field">
          Filtrar por
          <select v-model="selectedFieldKey" @change="draftValue = ''">
            <option v-for="field in fields" :key="field.key" :value="field.key">
              {{ field.label }}
            </option>
          </select>
        </label>

        <label
          v-if="selectedField && selectedField.options"
          class="additional-filters-field"
        >
          Escolha uma opção
          <select
            :key="selectedField.key"
            :value="draftFilters[selectedField.key] || ''"
            @change="addFilter($event.target.value)"
          >
            <option value="" disabled>Selecione</option>
            <option
              v-for="option in selectedField.options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </label>

        <div
          v-else-if="selectedField && !selectedField.options"
          class="additional-filters-field"
        >
          <label :for="`additional-filter-value-${_uid}`">{{
            selectedField.label
          }}</label>
          <div class="additional-filters-text">
            <input
              :id="`additional-filter-value-${_uid}`"
              v-model.trim="draftValue"
              type="text"
              :placeholder="selectedField.placeholder || selectedField.label"
              @keyup.enter.prevent="addFilter(draftValue)"
            />
            <button
              type="button"
              :disabled="!draftValue"
              @click="addFilter(draftValue)"
            >
              Adicionar
            </button>
          </div>
        </div>
      </div>

      <div v-if="activeFilters.length" class="additional-filters-applied">
        <div class="additional-filters-applied-header">
          <strong>Filtros selecionados</strong>
          <button type="button" @click="clear">Limpar todos</button>
        </div>
        <div class="additional-filters-chips">
          <span
            v-for="filter in activeFilters"
            :key="filter.key"
            class="additional-filters-chip"
          >
            <strong>{{ filter.label }}:</strong> {{ filter.text }}
            <button
              type="button"
              :aria-label="`Remover filtro ${filter.label}`"
              @click="$delete(draftFilters, filter.key)"
            >
              ×
            </button>
          </span>
        </div>
      </div>
    </div>
  </ModalConfirm>
</template>

<script>
import ModalConfirm from "../../Modals/ModalConfirm.vue";

export default {
  name: "AdditionalFiltersModal",
  components: { ModalConfirm },
  props: {
    fields: { type: Array, default: () => [] },
    appliedFilters: { type: Object, default: () => ({}) },
  },
  data() {
    return { draftFilters: {}, selectedFieldKey: "", draftValue: "" };
  },
  computed: {
    modalId() {
      return `additional-filters-${this._uid}`;
    },
    selectedField() {
      return (
        this.fields.find((field) => field.key === this.selectedFieldKey) ||
        this.fields[0]
      );
    },
    activeFilters() {
      return Object.entries(this.draftFilters)
        .filter(([, value]) => value !== "" && value != null)
        .map(([key, value]) => {
          const field = this.fields.find((item) => item.key === key);
          const option = field?.options?.find(
            (item) => String(item.value) === String(value)
          );
          return {
            key,
            label: field?.label || key,
            text: option?.text || value,
          };
        });
    },
  },
  methods: {
    open() {
      this.draftFilters = { ...this.appliedFilters };
      this.draftValue = "";
      if (!this.fields.some((field) => field.key === this.selectedFieldKey)) {
        this.selectedFieldKey = this.fields[0]?.key || "";
      }
      this.$emit("opening");
      this.$bvModal.show(this.modalId);
    },
    addFilter(value) {
      if (!value || !this.selectedField) return;
      this.$set(this.draftFilters, this.selectedField.key, value);
      this.draftValue = "";
    },
    clear() {
      this.draftFilters = {};
      this.draftValue = "";
    },
    apply() {
      this.$emit(
        "apply",
        Object.fromEntries(
          this.activeFilters.map(({ key }) => [key, this.draftFilters[key]])
        )
      );
    },
  },
};
</script>

<style scoped>
.additional-filters-content {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 16px;
}

.additional-filters-controls {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: end;
  gap: 16px;
}

.additional-filters-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
}

.additional-filters-field > label {
  margin: 0;
}

.additional-filters-field select,
.additional-filters-field input {
  width: 100%;
  min-width: 0;
  height: 36px;
  padding: 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background: white;
  font-size: 12px;
}

.additional-filters-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.additional-filters-chip {
  max-width: 100%;
  padding: 6px 10px;
  border: 1px solid #b7d5cf;
  border-radius: 6px;
  background: #f5faf8;
  color: #005c52;
  font-size: 12px;
}

.additional-filters-text {
  display: flex;
  gap: 8px;
  min-width: 0;
}

.additional-filters-text button {
  padding: 0 8px;
  border: 0;
  border-radius: 5px;
  background: #006256;
  color: white;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}

.additional-filters-text button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.additional-filters-applied {
  padding: 12px;
  border: 1px solid #dcece8;
  border-radius: 6px;
  background: #f8fbfa;
}

.additional-filters-applied-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
}

.additional-filters-applied-header button,
.additional-filters-chip button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #006256;
  cursor: pointer;
}

.additional-filters-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
}

.additional-filters-chip button {
  margin-left: 3px;
  font-size: 17px;
  line-height: 1;
}

@media (max-width: 575px) {
  .additional-filters-controls {
    grid-template-columns: 1fr;
  }
}
</style>
